/**
 * `/notifications`.
 *
 * The phone/tablet child screen (DetailHeader's back chevron, no BottomNav,
 * per the back contract). WP1 moved the actual feed — states, fetch/select
 * logic, copy resolvers — into components/NotificationsList.tsx so the same
 * body also serves NotificationsDrawer, the `lg`+ sibling this screen gives
 * way to (docs/DESIGN.md's "Notifications are a drawer from `lg`").
 */

import { createFileRoute } from '@tanstack/react-router';
import NotificationsList from '@/components/notifications-list';

export const Route = createFileRoute('/_protected/notifications')({
  component: NotificationsPage,
});

function NotificationsPage() {
  return <NotificationsList />;
}
